import { useSelector } from "react-redux";

import * as builder from "_metronic/ducks/builder";

function KtContent({ children }) {
  const animationEndClass = "kt-grid--animateContent-finished";

  // Redux selectors using useSelector hook
  const contentContainerClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "content_container",
      toString: true,
    })
  );

  return (
    <div
      className={`kt-container ${contentContainerClasses.split(" ")} kt-grid__item kt-grid__item--fluid ${animationEndClass}`}
    >
      {children}
    </div>
  );
}

export default KtContent;
